// test1280
(1280 && 0);
